import { Injectable } from '@angular/core';
import { B2BUser, EntitiesModel } from '@spartacus/core';
import { UserListService, UserModel } from '@spartacus/organization/administration/components';

@Injectable({
  providedIn: 'root',
})
export class SikoUserListService extends UserListService {

    protected convertUsers({
    pagination,
    sorts,
    values,
  }: EntitiesModel<B2BUser>): EntitiesModel<UserModel> {
    const availableRoles: string[] = ['b2bcustomergroup', 'b2badmingroup','b2btestaccountgroup'];
    const userModels: EntitiesModel<UserModel> = {
      pagination,
      sorts,
      values: values.map((value: any) => ({
        ...value,
        unit: value.orgUnit,
        roles: value.roles?.filter((role: any) =>
          availableRoles.includes(role)
        ),
      })),
    };
    return userModels;
  }
}
